export const fallbackAssetLabels = ['spt:bitcoin/btc', 'spt:ethereum/eth'];
